import React from 'react';
import classnames from "classnames";
import { withRouter } from "react-router"
import { connect } from 'react-redux';
import { withLocalize } from "react-localize-redux";
import { Translate } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { Link } from "react-router-dom";
import { reportActions, REPORTS, SECTIONS } from '../../../store/reportStore';
import ExcelExportButton from '../../common/excelExportButton';
import OldStyleTableWithHistory from '../../common/oldStyleTableWithHistory';

class RelatedAddresses extends React.Component {
    state = { page: 1 };

    get pageSize() {
        const limits = this.props.getSectionLimits(this.props.reportType || REPORTS.global, SECTIONS.relatedAddresses);
        return this.props.sectionId === SECTIONS.relatedAddresses ? limits.pageSize.unlimited : limits.pageSize.limited;
    }

    render() {
        const isLimited = this.props.sectionId !== SECTIONS.relatedAddresses;
        const { data } = isLimited
            ? this.props.sections.find(o => o.id === this.props.sectionId).subsections.find(q => q.id === this.props.subsectionId)
            : this.props.sections.find(o => o.id === this.props.sectionId);

        return data === undefined || data === null ? null : this.renderContent(data, isLimited);
    }

    renderContent = (data, isLimited) => {
        return (
            <div>
                <OldStyleTableWithHistory pageSize={this.pageSize} isLimited={isLimited}
                    head={this.renderHead} tableColumns={4} stripped classNames='related-addresses'
                    actualData={data.addresses} actualRow={a => this.renderAddress(a)}
                    showAllLink={this.props.getUnlimitedSectionLink(this.props.reportType, this.props.id, SECTIONS.relatedAddresses)}
                />
                <ExcelExportButton link="related-addresses" entityId={this.props.id} report={this.props.reportType} />
            </div>
        );
    }

    renderHead = () => {
        return (
            <thead>
                <tr>
                    <th rowSpan={2}><Translate id="Report.Relations.Address" /></th>
                    <th rowSpan={2} style={{width:'22%'}}><Translate id="Report.Relations.Address.Type" /></th>
                    <th colSpan="2" style={{width:'22%', textAlign:'center'}}>
                        <Translate id="Report.Relations.Address.Subjects" />
                    </th>
                    <th rowSpan={2} style={{width:'17%'}}><Translate id="Report.Common.Source" /></th>
                </tr>
                <tr>
                    <th style={{textAlign:'center'}}><Translate id="Common.Actual" /></th>
                    <th style={{textAlign:'center'}}><Translate id="Common.Historical" /></th>
                </tr>
            </thead>
        );
    }

    renderAddress = (data) => {
        if (data === undefined || data === null)
            return null;

        return (
            <tr key={data.entityId} className='colorize'>
                <td><Link className={classnames('link-functional', { 'is-normal': localStorage.locales_url_format === 'normal' })} to={{ pathname: `/related-address/${this.props.id}/${data.entityId}`}} target="_blank">{data.fullAddress}</Link></td>
                <td>{data.type}</td>
                <td style={{textAlign:'center'}}>{data.actualCount}</td>
                <td style={{textAlign:'center'}}>{data.historicalCount}</td>
                <td>{data.source}</td>
            </tr>
        );
    }
}

export default withRouter(withLocalize(connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(RelatedAddresses)));